import axiosInstance from '../axios';

/**
 * Gera uma Access Key temporaria para provisionamento IoT.
 * Tenta primeiro a rota tenant-aware e faz fallback para a rota legacy.
 */
export const gerarSecretIot = async (tenant, clientId) => {
    try {
        const response = await axiosInstance.post(`/${tenant}/secrets-iot`, null, {
            params: { clientId },
        });
        return response.data?.apiKey || response.data?.accessKey || response.data;
    } catch (error) {
        // Fallback para backend sem prefixo de tenant.
        if (tenant) {
            try {
                const fallback = await axiosInstance.post('/secrets-iot', null, {
                    params: { clientId: clientId || 'bootstrap' },
                });
                return (
                    fallback.data?.apiKey ||
                    fallback.data?.accessKey ||
                    fallback.data
                );
            } catch (fallbackError) {
                const message =
                    fallbackError?.response?.data?.message ||
                    fallbackError?.message ||
                    'Falha ao comunicar com o servidor para gerar a chave.';
                throw new Error(message);
            }
        }

        const message =
            error?.response?.data?.message ||
            error?.message ||
            'Falha ao comunicar com o servidor para gerar a chave.';
        throw new Error(message);
    }
};

// Compatibilidade com chamadas antigas.
export const generateIotSecret = async (clientId) =>
    gerarSecretIot(undefined, clientId);

const secretsIotApi = {
    gerarSecretIot,
    generateIotSecret,
};

export default secretsIotApi;
